import { useTranslation } from '@rhino-project/core/i18n';
import { useParams } from '@tanstack/react-router';

import { Typography } from '@heroui/react';
import { useModelIndex } from '@rhino-project/core/hooks';
import { BaseAuthedPage, MaxWidth } from '@rhino-project/ui-heroui';
import Lineup from '../../components/lineup/Lineup';

// Rhino adds display_name and other computed fields at runtime.
const DepthChartPage = () => {
  const { t } = useTranslation();

  const { team_season_id: teamSeasonId } = useParams({ strict: false });

  const { isPending, resources: lineups } = useModelIndex('lineup', {
    filter: { team_season_id: teamSeasonId, kind: 'depth_chart' },
    limit: 1,
    queryOptions: { enabled: !!teamSeasonId }
  });

  if (isPending) return null;

  const depthChart = lineups?.results?.[0];

  if (!depthChart) {
    return (
      <BaseAuthedPage>
        <MaxWidth>
          <p className="text-muted">
            {t('frontend.messages.no_depth_chart_found_for_this_season')}
          </p>
        </MaxWidth>
      </BaseAuthedPage>
    );
  }

  return (
    <BaseAuthedPage>
      <MaxWidth>
        <div className="flex justify-center">
          <Typography.Heading level={1} className="m-0">
            {t('frontend.messages.depth_chart')}
          </Typography.Heading>
        </div>
        <Lineup lineup={depthChart} />
      </MaxWidth>
    </BaseAuthedPage>
  );
};

export default DepthChartPage;
